// source: accounts/protos/vpnserver.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */


var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.accounts.protos.VPNServerAppStatus', null, global);
/**
 * @enum {number}
 */
proto.accounts.protos.VPNServerAppStatus = {
  VPNSERVER_APP_STATUS_UNCLAIMED: 0,
  VPNSERVER_APP_STATUS_DISABLED: 1,
  VPNSERVER_APP_STATUS_OFFLINE: 2,
  VPNSERVER_APP_STATUS_ONLINE: 3
};

goog.object.extend(exports, proto.accounts.protos);
